import axios from 'axios';
const BASE_URL = "http://localhost:3005";
const API_URL = `${process.env.REACT_APP_API_URL}/api`;

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json;charset=utf-8",
    Accept: "application/json",
  },
});

const externalAxios = axios.create({
  headers: {
    "Content-Type": "application/json;charset=utf-8",
    Accept: "application/json",
  },
});

const serialize = (object) => {
  return new URLSearchParams(object).toString();
};

const httpPostPromise = (url, payload, authorization = '') => {
  return externalAxios.post(url, payload, {
    headers: { Authorization: `Bearer ${authorization}` },
  });
};

const httpGetPromise = (url, payload = {}, authorization = '') => {
  return externalAxios.get(`${url}?${serialize(payload)}`, {
    headers: { Authorization: `Bearer ${authorization}` },
  });
};

const httpPutPromise = (url, payload, authorization = '') => {
  return externalAxios.put(url, payload, {
    headers: { Authorization: `Bearer ${authorization}` },
  });
};

const httpDeletePromise = (url, authorization = '') => {
  return externalAxios.delete(url, {
    headers: { Authorization: `Bearer ${authorization}` },
  });
};


const api = {
  pacientes: {
    getAll() {
      return axiosInstance.get("/pacientes").then(r => r.data);
    },
    getPacienteById() { },
    createPaciente() { },
    updatePaciente() { },
  },
  especialistas: {
    getAll() {
      return axiosInstance.get("/especialistas").then(r => r.data);
    },
    getPacienteById() { },
    createPaciente() { },
    updatePaciente() { },
  },
  recursos: {
    getAll() {
      return axiosInstance.get("/recursos").then(r => r.data);
    },
  },
  prestaciones: {
    getAll() {
      return axiosInstance.get("/prestaciones").then(r => r.data);
    },
  },
  cita: {
    saveCitas(payload, token) {
      return httpPostPromise(`${API_URL}/v1/citas`, payload, token);
    },
    updateCitas(id, payload, token) {
      return httpPutPromise(`${API_URL}/v1/citas/${id}`, payload, token);
    },
    deleteCitas(id, token) {
      return httpDeletePromise(`${API_URL}/v1/citas/${id}`, token);
    }
  },
  WhatsApp: {
    enviarMensaje(payload, token) {
      return httpPostPromise(`${API_URL}/v1/whatsappV2/send-message`, payload, token);
    },
    addConsersation(payload, token) {
      return httpPostPromise(`${API_URL}/v1/message/add-conversation`, payload, token);
    },
    getAllConversation(params, token) {
      return httpGetPromise(`${API_URL}/v1/message/get-message`, params, token);
    }
  },
  metaWhatsAppApi: {
    getAllBusinessRegistered(token) {
      return httpGetPromise(`${API_URL}/v1/whatsappV2/all-phone-business-meta`, {}, token);
    }
  }
};

export default api;
